import { createContext } from 'react';

interface AppValue {
  price: [number, number];
  changePrice: (v: [number, number]) => void;
}

const appDefaultValue: AppValue = {
  price: [0, 0],
  changePrice: () => {},
};

export default createContext(appDefaultValue);
